import {
	faAlignCenter,
	faAlignJustify,
	faAlignLeft,
	faAlignRight,
	faAngleDoubleLeft,
	faAngleDoubleRight,
	faAngleRight,
	faArrowDown,
	faArrowPointer,
	faArrowLeft,
	faArrowRight,
	faArrowRightArrowLeft,
	faArrowUp,
	faArrowUpFromBracket,
	faArrowUpRightFromSquare,
	faArrowUpZA,
	faArrowsRotate,
	faClockRotateLeft,
	faAsterisk,
	faAt,
	faBan,
	faBars,
	faBarsStaggered,
	faBell,
	faBold,
	faBookOpen,
	faBookOpenReader,
	faBookmark,
	faBoxArchive,
	faBriefcase,
	faBuilding,
	faCalendar,
	faCalendarAlt,
	faCalendarCheck,
	faCalendarDay,
	faCaretDown,
	faCaretLeft,
	faCaretRight,
	faCaretUp,
	faChartColumn,
	faChartPie,
	faCheck,
	faCheckCircle,
	faCheckDouble,
	faCheckSquare,
	faCheckToSlot,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faCloudArrowUp,
	faClipboardCheck,
	faClipboardList,
	faClock,
	faCloudDownload,
	faCode,
	faCodeBranch,
	faCodeFork,
	faCog,
	faColumns,
	faComment,
	faComments,
	faCompassDrafting,
	faCopy,
	faCubes,
	faDatabase,
	faDesktop,
	faDiagramProject,
	faDownLeftAndUpRightToCenter,
	faDownload,
	faDraftingCompass,
	faEllipsisH,
	faEllipsisV,
	faEnvelope,
	faEnvelopeOpen,
	faEquals,
	faEuroSign,
	faExchangeAlt,
	faExclamation,
	faExclamationCircle,
	faExclamationTriangle,
	faEye,
	faEyeSlash,
	faFile,
	faFileAlt,
	faFileArrowUp,
	faFileExcel,
	faFileExport,
	faFileImport,
	faFileLines,
	faFilePdf,
	faFileSignature,
	faFileUpload,
	faFileWord,
	faFileZipper,
	faFilter,
	faFlag,
	faFlask,
	faFlaskVial,
	faFloppyDisk,
	faFolder,
	faFolderOpen,
	faFolderPlus,
	faFolderTree,
	faGavel,
	faGear,
	faGlobe,
	faGraduationCap,
	faGripLines,
	faHeading,
	faHammer,
	faHandPaper,
	faHandPointUp,
	faHandsHelping,
	faHandshakeAngle,
	faHashtag,
	faHistory,
	faHome,
	faHourglassHalf,
	faInbox,
	faInfo,
	faInfoCircle,
	faItalic,
	faKey,
	faLandmark,
	faLayerGroup,
	faLightbulb,
	faLink,
	faList,
	faList12,
	faLocationCrosshairs,
	faLock,
	faLockOpen,
	faMinus,
	faMinusCircle,
	faMinusSquare,
	faMoneyCheck,
	faNotEqual,
	faNoteSticky,
	faObjectGroup,
	faObjectUngroup,
	faPaperPlane,
	faPen,
	faPenFancy,
	faPenRuler,
	faPenToSquare,
	faPlay,
	faPlus,
	faPlusCircle,
	faPlusSquare,
	faQuestionCircle,
	faQuoteLeft,
	faRadiation,
	faRectangleList,
	faRedoAlt,
	faRefresh,
	faRobot,
	faRotate,
	faRotateRight,
	faSave,
	faScrewdriverWrench,
	faSearch,
	faShapes,
	faShareAlt,
	faShield,
	faShieldAlt,
	faShieldHalved,
	faSignInAlt,
	faSitemap,
	faSliders,
	faSort,
	faSortAmountDown,
	faSortAmountUp,
	faSortDown,
	faSortUp,
	faSpinner,
	faSquare,
	faSquarePollVertical,
	faSquareXmark,
	faStairs,
	faStar,
	faStarOfLife,
	faStopwatch,
	faStepBackward,
	faStepForward,
	faStream,
	faStrikethrough,
	faSwatchbook,
	faSyncAlt,
	faTable,
	faTableList,
	faTag,
	faTicketSimple,
	faThumbsDown,
	faThumbsUp,
	faThumbtack,
	faTimes,
	faTimesCircle,
	faTrash,
	faTrashArrowUp,
	faTrophy,
	faTriangleExclamation,
	faUnderline,
	faUndo,
	faUnlink,
	faUpRightAndDownLeftFromCenter,
	faUpRightFromSquare,
	faUpload,
	faUser,
	faUserCheck,
	faUserCog,
	faUserEdit,
	faUserFriends,
	faUserPlus,
	faUserTie,
	faUsers,
	faWandMagic,
	faWandMagicSparkles,
	faImage,
	faCamera,
	faEdit,
	faWrench,
	faXmark,
	faArrowDownAZ,
	faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
	faCalendarCheck as faCalendarCheckRegular,
	faChartBar as faChartBarRegular,
	faCheckCircle as faCheckCircleRegular,
	faCirclePlay as faCirclePlayRegular,
	faClock as faClockRegular,
	faFile as faFileRegular,
	faFileArchive as faBoxArchiveRegular,
	faFloppyDisk as faFloppyDiskRegular,
	faHourglass as faHourglassRegular,
	faQuestionCircle as faQuestionCircleRegular,
	faSquare as faSquareRegular,
	faStar as faStarRegular,
	faTimesCircle as faTimesCircleRegular,
} from "@fortawesome/free-regular-svg-icons";

import {
	aitArrowDownClock,
	aitArrowUpClock,
	aitCheckCircle,
	aitClock,
	aitClipBoardCheck,
	aitEqualsCircle,
	aitHourglassCircle,
	aitNotEqualsCircle,
	aitSearchMinus,
	aitSearchPlus,
	aitStar,
	aitTimesCircle,
} from "../../resources/icons";

export default {
	aitArrowDownClock,
	aitArrowUpClock,
	aitEqualsCircle,
	aitHourglassCircle,
	aitNotEqualsCircle,
	aitClipBoardCheck,
	aitSearchMinus,
	aitSearchPlus,
	aitStar,
	aitTimesCircle,
	aitCheckCircle,
	aitClock,
	faAlignCenter,
	faAlignJustify,
	faAlignLeft,
	faAlignRight,
	faAngleDoubleLeft,
	faAngleDoubleRight,
	faAngleRight,
	faArrowDown,
	faArrowDownAZ,
	faArrowPointer,
	faArrowLeft,
	faArrowRight,
	faArrowRightArrowLeft,
	faArrowUp,
	faArrowUpFromBracket,
	faArrowUpRightFromSquare,
	faArrowUpZA,
	faArrowsRotate,
	faClockRotateLeft,
	faAsterisk,
	faAt,
	faBan,
	faBars,
	faBarsStaggered,
	faBell,
	faBold,
	faBookOpen,
	faBookOpenReader,
	faBookmark,
	faEdit,
	faBoxArchive,
	faBoxArchiveRegular,
	faBriefcase,
	faBuilding,
	faImage,
	faCamera,
	faCalendar,
	faCalendarAlt,
	faCalendarCheck,
	faCalendarCheckRegular,
	faCalendarDay,
	faCaretDown,
	faCaretLeft,
	faCaretRight,
	faCaretUp,
	faChartBarRegular,
	faChartColumn,
	faChartPie,
	faCheck,
	faCheckCircle,
	faCheckCircleRegular,
	faCheckDouble,
	faCheckSquare,
	faCheckToSlot,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faCircle,
	faCirclePlayRegular,
	faCloudArrowUp,
	faClipboardCheck,
	faClipboardList,
	faClock,
	faClockRegular,
	faCloudDownload,
	faCode,
	faCodeBranch,
	faCodeFork,
	faCog,
	faColumns,
	faComment,
	faComments,
	faCompassDrafting,
	faCopy,
	faCubes,
	faDatabase,
	faDesktop,
	faDiagramProject,
	faDownLeftAndUpRightToCenter,
	faDownload,
	faDraftingCompass,
	faEllipsisH,
	faEllipsisV,
	faEnvelope,
	faEnvelopeOpen,
	faEquals,
	faEuroSign,
	faExchangeAlt,
	faExclamation,
	faExclamationCircle,
	faExclamationTriangle,
	faEye,
	faEyeSlash,
	faFile,
	faFileAlt,
	faFileArchive: faBoxArchive,
	faFileArchiveRegular: faBoxArchiveRegular,
	faFileArrowUp,
	faFileExcel,
	faFileExport,
	faFileImport,
	faFileLines,
	faFilePdf,
	faFileRegular,
	faFileSignature,
	faFileUpload,
	faFileWord,
	faFileZipper,
	faFilter,
	faFlag,
	faFlask,
	faFlaskVial,
	faFloppyDisk,
	faFloppyDiskRegular,
	faFolder,
	faFolderOpen,
	faFolderPlus,
	faFolderTree,
	faGavel,
	faGear,
	faGlobe,
	faGraduationCap,
	faGripLines,
	faHeading,
	faHammer,
	faHandPaper,
	faHandPointUp,
	faHandsHelping,
	faHandshakeAngle,
	faHashtag,
	faHistory,
	faHome,
	faHourglassHalf,
	faHourglassRegular,
	faInbox,
	faInfo,
	faInfoCircle,
	faItalic,
	faKey,
	faLandmark,
	faLayerGroup,
	faLightbulb,
	faLink,
	faList,
	faList12,
	faLocationCrosshairs,
	faLock,
	faLockOpen,
	faMinus,
	faMinusCircle,
	faMinusSquare,
	faMoneyCheck,
	faNotEqual,
	faNoteSticky,
	faObjectGroup,
	faObjectUngroup,
	faPaperPlane,
	faPen,
	faPenFancy,
	faPenRuler,
	faPenToSquare,
	faPlay,
	faPlus,
	faPlusCircle,
	faPlusSquare,
	faQuestionCircle,
	faQuoteLeft,
	faQuestionCircleRegular,
	faRadiation,
	faRectangleList,
	faRedoAlt,
	faRefresh,
	faRobot,
	faRotate,
	faRotateRight,
	faSave,
	faScrewdriverWrench,
	faSearch,
	faShapes,
	faShareAlt,
	faShield,
	faShieldAlt,
	faShieldHalved,
	faSignInAlt,
	faSitemap,
	faSliders,
	faSort,
	faSortAmountDown,
	faSortAmountUp,
	faSortDown,
	faSortUp,
	faSpinner,
	faSquare,
	faSquarePollVertical,
	faSquareRegular,
	faSquareXmark,
	faStairs,
	faStar,
	faStarOfLife,
	faStarRegular,
	faStopwatch,
	faStepBackward,
	faStepForward,
	faStream,
	faStrikethrough,
	faSwatchbook,
	faSyncAlt,
	faTable,
	faTableList,
	faTag,
	faTicketSimple,
	faThumbsDown,
	faThumbsUp,
	faThumbtack,
	faTimes,
	faTimesCircle,
	faTimesCircleRegular,
	faTrash,
	faTrashArrowUp,
	faTrophy,
	faTriangleExclamation,
	faUnderline,
	faUndo,
	faUnlink,
	faUpRightAndDownLeftFromCenter,
	faUpRightFromSquare,
	faUpload,
	faUser,
	faUserCheck,
	faUserCog,
	faUserEdit,
	faUserFriends,
	faUserPlus,
	faUserTie,
	faUsers,
	faWandMagic,
	faWandMagicSparkles,
	faWrench,
	faXmark,
	faCircleXmark,
};
